import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as Sentry from "@sentry/react";

// ==============================================================================
// SENTRY ERROR MONITORING (Frontend)
// ==============================================================================
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN_FRONTEND;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "preview",
    release: process.env.REACT_APP_SENTRY_RELEASE || "titleflow-frontend@1.0.0",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 0.5,
    beforeSend(event) {
      // Filter out ResizeObserver noise
      if (event.exception?.values?.some(v => v.value?.includes('ResizeObserver'))) {
        return null;
      }
      return event;
    },
  });
  console.log(`[Sentry] Initialized for environment: ${process.env.REACT_APP_SENTRY_ENVIRONMENT || 'preview'}`);
} else {
  console.log("[Sentry] REACT_APP_SENTRY_DSN_FRONTEND not set — error monitoring disabled");
}

// Fix ResizeObserver loop error - patch the observer to debounce callbacks
// This is a known browser issue with UI components like dialogs/modals
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // Use requestAnimationFrame to debounce and prevent the loop error
      window.requestAnimationFrame(() => {
        if (document.hidden) return; // Skip if tab is not visible
        callback(entries, observer);
      });
    });
  }
};

// Also suppress any uncaught ResizeObserver errors
const suppressResizeObserverError = (e) => {
  if (e.message?.includes('ResizeObserver loop') || 
      e.message?.includes('ResizeObserver loop completed')) {
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
    return true;
  }
};
window.addEventListener('error', suppressResizeObserverError);
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message?.includes('ResizeObserver')) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
